// @ngInject
function updateAddressDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, address) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'updateAddressDialogController as vm',
            templateUrl: 'services/dialogs/updateAddressDialog/updateAddressDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            address: function() {
                return address;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function updateAddressDialogController($uibModalInstance, message, address) {
    var vm = this;

    vm.message = message;
    vm.address = address;

    vm.closeModal = closeModal;
    vm.save = save;

    function closeModal(isCompleted) {
        $uibModalInstance.close({
            isCompleted: isCompleted,
            address: null
        });
    }

    function save() {
        $uibModalInstance.close({
            isCompleted: true,
            address: vm.address
        });
    }
}

angular
    .module('services.dialogs.updateAddressDialog', [])
    .service('updateAddressDialogService', updateAddressDialogService)
    .controller('updateAddressDialogController', updateAddressDialogController);
